import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { JoditAngularModule } from 'jodit-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RegisterComponent } from './register/register.component';
import { StepsProgressComponent } from './components/steps-progress/steps-progress.component';
import { TableComponent } from './components/ui/table/table.component';
import { NgxSmartModalModule } from "ngx-smart-modal";
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BaseComponent } from './components/base/base.component';
import { FormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { RegisterUserComponent } from './register/register-user/register-user.component';
import { RegisterAgentComponent } from './register/register-agent/register-agent.component';
import { RegisterCompanyComponent } from './register/register-company/register-company.component';
import { REGISTER_COMPANY_STEP_COMPONENTS } from './register/register-company';
import { RegisterStaffComponent } from './register/register-staff/register-staff.component';
import { RecapComponent } from './components/ui/recap/recap.component';
import { NavbarComponent } from './components/ui/navbar/navbar.component';
import { FooterComponent } from './components/ui/footer/footer.component';
import { DashboardAthleteComponent } from './components/dashboard/dashboard-athlete/dashboard-athlete.component';
import { AthleteConvocationsComponent } from './components/dashboard/dashboard-athlete/athlete-convocations/athlete-convocations.component';
import { DashboardCompanyComponent } from './components/dashboard/dashboard-company/dashboard-company.component';
import { AthleteCardComponent } from './components/ui/athlete-card/athlete-card.component';
import { LinkBoxComponent } from './components/ui/link-box/link-box.component';
import { FileFieldComponent } from './components/ui/file-field/file-field.component';
import { AddressSearchComponent } from './components/ui/address-search/address-search.component';
import { PhoneFieldComponent } from './components/ui/phone-field/phone-field.component';
import { AuthGuard } from './secure';
import { DashboardAgentComponent } from './components/dashboard/dashboard-agent/dashboard-agent.component';
import { DashboardAdminComponent } from './components/dashboard/dashboard-admin/dashboard-admin.component';
import { DashboardMisterComponent } from './components/dashboard/dashboard-mister/dashboard-mister.component';
import { DashboardMisterConvocationsRowComponent } from './components/dashboard/dashboard-mister/convocations-row/convocations-row.component';
import { DashboardMisterLatestConvocationCardComponent } from './components/dashboard/dashboard-mister/latest-convocation-card/latest-convocation-card.component';
import { DashboardMisterConvocationsTableComponent } from './components/dashboard/dashboard-mister/convocations-table/convocations-table.component';
import { DashboardMisterConvocationDetailComponent } from './components/dashboard/dashboard-mister/mister-convocation-detail/mister-convocation-detail.component';
import { MisterConvocationFormComponent } from './components/dashboard/dashboard-mister/mister-convocation-form/mister-convocation-form.component';
import { CompaniesListComponent } from './components/companies-list/company-list.component';
import { AgentsListComponent } from './components/agents-list/agents-list.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { NgOptimizedImage } from "@angular/common";
import { AthleteDocumentsComponent } from './components/athlete-documents/athlete-documents.component';
import { UserSubscriptionsComponent } from './components/user-subscriptions/user-subscriptions.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { InvoicesListComponent } from './components/invoices-list/invoices-list.component';
import { CategoriesListComponent } from './components/categories-list/categories-list.component';
import { CompaniesSubscriptionsComponent } from './components/companies-subscriptions/companies-subscriptions.component';
import { SubscriptionsCategoryComponent } from './components/subscriptions-category/subscriptions-category.component';
import { CompaniesSettingsComponent } from './components/companies-settings/companies-settings.component';
import { COMPANIES_SETTINGS_CHILD_COMPONENTS } from './components/companies-settings';
import { AgentDetailsComponent } from './components/agent/agent-details/agent-details.component';
import { HttpInterceptorInterceptor } from "./http-interceptor.interceptor";
import { PaymentComponent } from './components/payment/payment.component';
import { ReservedAreaComponent } from './components/reserved-area/reserved-area.component';
import { ThankyouComponent } from './components/thankyou/thankyou.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { IbanPageComponent } from './components/iban-page/iban-page.component';
import { MessagesComponent } from './components/messages/messages.component';
import { MessagesInboxComponent } from './components/ui/messages-inbox/messages-inbox.component';
import { MessageDetailsComponent } from './components/ui/message-details/message-details.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { CompanyBoardingComponent } from './components/company-boarding/company-boarding.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordEmailComponent } from './components/reset-password-email/reset-password-email.component';
import { AdminsSettingsComponent } from './components/admins-settings/admins-settings.component';
import { AdminSubscriptionsComponent } from './components/admin-subscriptions/admin-subscriptions.component';
import { MembershipComponent } from './components/membership/membership.component';
import { AdminAllusersComponent } from './components/admin-allusers/admin-allusers.component';
import { AdminUserDetailComponent } from './components/admin-allusers/user-detail/admin-user-detail.component';
import { IdentityAvatarComponent } from './components/ui/identity-avatar/identity-avatar.component';
import { AdminDomainsComponent } from './components/admin-domains/admin-domains.component';
import { CompaniesAllusersComponent } from "./components/companies-allusers/companies-allusers.component";
import { AdminAllAthletesComponent } from './components/admin-allathletes/admin-allathletes.component';
import { OtpPageComponent } from './components/otp-page/otp-page.component';
import { CompaniesShopComponent } from "./components/companies-shop/companies-shop.component";
import { SizeComponent } from './components/companies-shop/size/size.component';
import { ColorComponent } from './components/companies-shop/color/color.component';
import { ShopCategoryComponent } from './components/companies-shop/category/shop-category.component';
import { ImageGalleryComponent } from "./components/companies-shop/image-gallery/image-gallery.component";
import { ShopComponent } from './components/shop/shop.component';
import { EditProductComponent } from './components/companies-shop/edit-product/edit-product.component';
import { BarcodeComponent } from './components/companies-shop/barcode/barcode.component';
import { EditBarcodeComponent } from './components/companies-shop/barcode/edit-barcode/edit-barcode.component';
import { BarcodeMovementComponent } from './components/companies-shop/barcode/barcode-movement/barcode-movement.component';
import { BarcodeMovementEditComponent } from './components/companies-shop/barcode/barcode-movement/barcode-movement-edit/barcode-movement-edit.component';
import { ShopNavbarComponent } from './components/ui/shop-navbar/shop-navbar.component';
import { CartComponent } from './components/shop/cart/cart.component';
import { CheckoutComponent } from './components/shop/checkout/checkout.component';
import { CheckoutDetailsComponent } from './components/shop/checkout/checkout-details/checkout-details.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OrdersComponent } from './components/companies-shop/orders/orders.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { WelldoneMultiselectComponent } from './components/ui/welldone-multiselect/welldone-multiselect.component';
import { StripeEmbeddedCheckoutComponent } from './components/stripe-embedded-checkout/stripe-embedded-checkout.component';
import { CompanySubscriptionRequiredComponent } from './components/company-subscription-required/company-subscription-required.component';
import { CompanyPaymentIssueComponent } from './components/company-payment-issue/company-payment-issue.component';
import { AthleteNewComponent } from './components/athlete-new/athlete-new.component';
import { RecurringPaymentDetailsComponent } from './components/recurring-payment-details/recurring-payment-details.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TagModule } from 'primeng/tag';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        RegisterComponent,
        StepsProgressComponent,
        TableComponent,
        BaseComponent,
        RegisterUserComponent,
        RegisterAgentComponent,
        RegisterCompanyComponent,
        ...REGISTER_COMPANY_STEP_COMPONENTS,
        RegisterStaffComponent,
        RecapComponent,
        NavbarComponent,
        FooterComponent,
        DashboardAthleteComponent,
        AthleteConvocationsComponent,
        DashboardCompanyComponent,
        AthleteCardComponent,
        LinkBoxComponent,
        FileFieldComponent,
        AddressSearchComponent,
        PhoneFieldComponent,
        DashboardAgentComponent,
        DashboardAdminComponent,
        DashboardMisterComponent,
        DashboardMisterConvocationsRowComponent,
        DashboardMisterLatestConvocationCardComponent,
        DashboardMisterConvocationsTableComponent,
        DashboardMisterConvocationDetailComponent,
        MisterConvocationFormComponent,
        CompaniesListComponent,
        AgentsListComponent,
        EditProfileComponent,
        AthleteDocumentsComponent,
        UserSubscriptionsComponent,
        EditUserComponent,
        InvoicesListComponent,
        CategoriesListComponent,
        CompaniesSubscriptionsComponent,
        SubscriptionsCategoryComponent,
        CompaniesSettingsComponent,
        ...COMPANIES_SETTINGS_CHILD_COMPONENTS,
        AgentDetailsComponent,
        PaymentComponent,
        ThankyouComponent,
        ErrorPageComponent,
        IbanPageComponent,
        MessagesComponent,
        MessagesInboxComponent,
        MessageDetailsComponent,
        ResetPasswordComponent,
        CompanyBoardingComponent,
        ForgotPasswordComponent,
        ResetPasswordEmailComponent,
        AdminsSettingsComponent,
        AdminSubscriptionsComponent,
        MembershipComponent,
        AdminAllusersComponent,
        AdminUserDetailComponent,
        IdentityAvatarComponent,
        AdminDomainsComponent,
        AdminAllAthletesComponent,
        CompaniesAllusersComponent,
        OtpPageComponent,
        CompaniesShopComponent,
        SizeComponent,
        ColorComponent,
        ShopCategoryComponent,
        ImageGalleryComponent,
        ShopComponent,
        EditProductComponent,
        BarcodeComponent,
        EditBarcodeComponent,
        BarcodeMovementComponent,
        BarcodeMovementEditComponent,
        ShopNavbarComponent,
        CartComponent,
        CheckoutComponent,
        CheckoutDetailsComponent,
        OtpPageComponent,
        OrdersComponent,
        WelldoneMultiselectComponent,
        StripeEmbeddedCheckoutComponent,
        CompanySubscriptionRequiredComponent,
        CompanyPaymentIssueComponent,
        RecurringPaymentDetailsComponent,
        AthleteNewComponent,
        ReservedAreaComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        NgxSmartModalModule.forRoot(),
        FullCalendarModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule.forRoot({ type: 'ball-spin' }),
        NgOptimizedImage,
        JoditAngularModule,
        NgMultiSelectDropDownModule,
        ReactiveFormsModule,
        NgApexchartsModule,
        TableModule,
        ButtonModule,
        OverlayPanelModule,
        SidebarModule,
        InputTextModule,
        DropdownModule,
        MultiSelectModule,
        InputSwitchModule,
        TagModule,
        SkeletonModule,
        TooltipModule

    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorInterceptor, multi: true
        },
        AuthGuard,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
